import * as React from "react";
const SvgDefAvatarIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 28 28", fill: "none", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 14, cy: 14, r: 14, fill: "#F2F2F2" }));
export default SvgDefAvatarIcon;
